import React from 'react';

import { Input, InputNumber, Select, AutoComplete, TimePicker, DatePicker } from 'antd';

const { RangePicker } = DatePicker;
const { TextArea } = Input;

const FormInput = React.forwardRef((props, ref) => {
    return <Input autoComplete="off" {...props} ref={ref} />;
});

const FormTextArea = React.forwardRef((props, ref) => {
    return <TextArea autoComplete="off" {...props} rows={5} ref={ref} />;
});

const FormTextAreaAutocomplete = React.forwardRef((props, ref) => {
    const { options, maxLength, ...rest } = props;
    const wrapperRef = React.useRef(null);

    React.useEffect(() => {
        if (wrapperRef.current && maxLength !== undefined) {
            const textarea = wrapperRef.current.querySelector('textarea');
            if (textarea) {
                textarea.maxLength = maxLength;
            }
        }
    }, [maxLength]);

    return (
        <div ref={wrapperRef}>
            <AutoComplete popupClassName="form-autocomplete-popup" options={options}>
                <TextArea autoComplete="off" {...rest} rows={5} ref={ref} />
            </AutoComplete>
        </div>
    );
});

const FormInputNumber = React.forwardRef((props, ref) => {
    return <InputNumber autoComplete="off" {...props} ref={ref} />;
});

const FormSelect = (props) => {
    return <Select autoComplete="off" {...props} />;
};

const FormAutoComplete = (props) => {
    return <AutoComplete popupClassName="form-autocomplete-popup" {...props} />;
};

const FormTimePicker = (props) => {
    return <TimePicker autoComplete="off" {...props} />;
};

const FormRangePicker = (props) => {
    return <RangePicker autoComplete="off" {...props} />;
};

export {
    FormInput,
    FormInputNumber,
    FormSelect,
    FormAutoComplete,
    FormTextAreaAutocomplete,
    FormTimePicker,
    FormRangePicker,
    FormTextArea,
};
